import { ref, Ref, computed } from 'vue'
import { useRoute } from 'vue-router'

import { ColumnFilter, ColumnFilterType, DataType, TableColumn } from '@/types/table'

export default function useColumnFiltering() {
    const route = useRoute()

    let parsedColumnFilters = {}
    if (route.query.columnFilters) {
        parsedColumnFilters = JSON.parse(route.query.columnFilters.toString())
    }

    const filters: Ref<Record<string, ColumnFilter[]>> = ref(parsedColumnFilters)

    const filtersAsQueryString = computed(() => {
        const valid: Record<string, ColumnFilter[]> = {}

        for (const [property, columnFilters] of Object.entries(filters.value)) {
            const nonEmptyFilters = columnFilters.filter((filter) => {
                if (Array.isArray(filter.value)) {
                    return filter.value.length === 2
                }
                return filter.value.trim().length > 0
            })

            if (nonEmptyFilters.length > 0) {
                valid[property] = nonEmptyFilters
            }
        }

        if (Object.keys(valid).length === 0) {
            return undefined
        }

        return JSON.stringify(valid)
    })

    function emptyFilter(column: TableColumn): ColumnFilter {
        if (column.filterable?.dataType === DataType.Date) {
            return { value: [], type: ColumnFilterType.Between }
        }

        return { value: '', type: ColumnFilterType.Contains }
    }

    return {
        filters,
        filtersAsQueryString,
        addFilter(column: TableColumn) {
            if (!filters.value[column.property]) {
                filters.value[column.property] = [emptyFilter(column)]
            } else {
                filters.value[column.property].push(emptyFilter(column))
            }
        },
        removeFilter(column: TableColumn, itemIndex: number) {
            if (!filters.value[column.property]) return
            filters.value[column.property].splice(itemIndex, 1)
        },
        clearFilters(column: TableColumn) {
            filters.value[column.property] = [emptyFilter(column)]
        },
        clearAllFilters() {
            filters.value = {}
        },
    }
}
